export default __webpack_public_path__ + "static/media/128.ab00103f.png";